import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/view/login/login'
import Register from '@/view/login/register'
import ForgetPwd from '@/view/login/forgetPwd'

import Home from '@/view/home'

import ProductDetails from '@/view/other/productDetails'
import Product from '@/view/other/product'

import ProductShop from '@/view/shop/productShop'
import Shop from '@/view/shop/shop'
import ShopJpDetailsBuy from '@/view/shop/shopJpDetailsBuy'
import ShopJpDetailsSell from '@/view/shop/shopJpDetailsSell'
import ShopYxmhDetailsBuy from '@/view/shop/shopYxmhDetailsBuy'
import ShopYxmhDetailsSell from '@/view/shop/shopYxmhDetailsSell'
import OrderYXMH from '@/view/shop/orderYxmh'
import OrderJp from '@/view/shop/orderJp'

import switchover from '@/view/switchover'
import Notice from '@/view/notice/notice'
import NoticeDetails from '@/view/notice/noticeDetails'

import Me from '@/view/me/me'
import Info from '@/view/me/info'
import MyOrder from '@/view/me/myOrder'
import CompanyList from '@/view/me/companyList'
import Company from '@/view/me/company'
import Geren from '@/view/me/geren'

import Publish from '@/view/me/publish'
import PublishJP from '@/view/me/publishJP'
import PublishYXMH from '@/view/me/PublishYXMH'

Vue.use(Router)

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err);
}

export default new Router({
    routes: [{
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
            },
        },
        {
            path: '/product_details',
            name: 'ProductDetails',
            component: ProductDetails,
            meta: {
                name: '',
                breadcrumb: []
            }
        },
        {
            path: '/product',
            name: 'Product',
            component: Product,
            meta: {
                name: '产品分类',
                breadcrumb: []
            }
        },
        {
            path: '/product_shop',
            name: 'ProductShop',
            component: ProductShop,
            meta: {
                name: '产品列表',
                breadcrumb: []
            }
        },
        {
            path: '/shop_auction',
            name: 'ShopAuction',
            component: Shop,
            meta: {
                name: '竞拍产品列表',
                breadcrumb: []
            }
        },
        {
            path: '/shop_yxmh',
            name: 'ShopYXMH',
            component: Shop,
            meta: {
                name: '意向卖货产品列表',
                breadcrumb: []
            }
        },
        {
            path: '/shop_jp_details_buy',
            name: 'ShopJpDetailsBuy',
            component: ShopJpDetailsBuy,
            meta: {
                name: '竞拍产品详情',
                breadcrumb: [{
                    path: '/shop_auction',
                    label: '竞拍产品列表'
                }]
            }
        },
        {
            path: '/shop_jp_details_sell',
            name: 'ShopJpDetailsSell',
            component: ShopJpDetailsSell,
            meta: {
                name: '竞拍产品详情',
                breadcrumb: [{
                    path: '/shop_auction',
                    label: '竞拍产品列表'
                }],
            }
        },
        {
            path: '/shop_yxmh_details_buy',
            name: 'ShopYxmhDetailsBuy',
            component: ShopYxmhDetailsBuy,
            meta: {
                name: '意向卖货产品详情',
                breadcrumb: [{
                    path: '/shop_yxmh',
                    label: '意向卖货产品列表'
                }],
            }
        },
        {
            path: '/shop_yxmh_details_sell',
            name: 'ShopYxmhDetailsSell',
            component: ShopYxmhDetailsSell,
            meta: {
                name: '意向卖货产品详情',
                breadcrumb: [{
                    path: '/shop_yxmh',
                    label: '意向卖货产品列表'
                }],
            }
        },
        {
            path: '/order_yxmh',
            name: 'OrderYXMH',
            component: OrderYXMH,
            meta: {
                name: '意向卖货订单详情',
                breadcrumb: [{
                    path: '/shop_yxmh',
                    label: '意向卖货产品列表'
                }],
            }
        },
        {
            path: '/order_jp',
            name: 'OrderJp',
            component: OrderJp,
            meta: {
                name: '竞拍订单详情',
                breadcrumb: [{
                    path: '/shop_auction',
                    label: '竞拍产品列表'
                }],
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                noFooter: true,
                isHeaderLeft: true,
                noTable: true,
            },
        },
        {
            path: '/register',
            name: 'Register',
            component: Register,
            meta: {
                noFooter: true,
                isHeaderLeft: true,
                noTable: true,
            },
        },
        {
            path: '/forget_pwd',
            name: 'ForgetPwd',
            component: ForgetPwd,
            meta: {
                noFooter: true,
                isHeaderLeft: true,
                noTable: true,
            },
        },
        {
            path: '/switchover',
            name: 'switchover',
            component: switchover,
            meta: {
                isHorFshow: false,
            },
        },
        {
            path: '/notice',
            name: 'Notice',
            component: Notice,
            meta: {
                name: '公告通知',
                breadcrumb: [],
            }
        },
        {
            path: '/notice_details',
            name: 'NoticeDetails',
            component: NoticeDetails,
            meta: {
                name: '公告通知详情',
                breadcrumb: [{
                    path: '/notice',
                    label: '公告通知'
                }],
            }
        },
        {
            path: '/me',
            name: 'Me',
            component: Me,
            meta: {},
            children: [{
                    path: '/',
                    name: 'Info',
                    component: Info,
                },
                {
                    path: '/my_order',
                    name: 'MyOrder',
                    component: MyOrder,
                },
                {
                    path: '/company_list',
                    name: 'CompanyList',
                    component: CompanyList,
                },
                {
                    path: '/Company',
                    name: 'Company',
                    component: Company,
                    meta: {},
                },
                {
                    path: '/geren',
                    name: 'Geren',
                    component: Geren,
                },
                {
                    path: '/publish',
                    name: 'Publish',
                    component: Publish,
                    children: [{
                        path: '/',
                        name: 'PublishJP',
                        component: PublishJP,
                    }, {
                        path: '/publish_yxmh',
                        name: 'PublishYXMH',
                        component: PublishYXMH,
                    }],
                },
            ],
        },
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js